var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"left-sidebar",attrs:{"data-sidebarbg":"skin5"}},[_c('div',{staticClass:"scroll-sidebar"},[_c('Navigation',{ref:"nav"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }